import { __ } from '@wordpress/i18n';
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';

const save = (props) => {
  const { mbModalID, mbModalContentType } = props.attributes;

  // Learnings. Save.js/Save function can not have usestate or other interactivity. It is only to give HTMl.
  // -- Note: The save function should be a pure function that depends only on the attributes used to invoke it. (https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/)
  // You cannot use two inner blocks in edit or save. You are only allowed one.
  // -- Note: A block can render at most a single InnerBlocks and InnerBlocks.Content element in edit and save respectively. To create distinct arrangements of nested blocks, create a separate block type which renders its own InnerBlocks and assign as the sole allowedBlocks type. (https://github.com/WordPress/gutenberg/tree/trunk/packages/block-editor/src/components/inner-blocks)

  return (
    <div {...useBlockProps.save()}>
      {mbModalContentType == 'htr-modal-trigger' ? (
        <div className='htr-modal-trigger' data-modal-id={mbModalID}>
          <InnerBlocks.Content />
        </div>
      ) : (
        <dialog
          className='htr-modal-content htr-modal-content-hide'
          data-modal-id={mbModalID}
        >
          <div className='htr-modal-content-background'></div>
          <div className='htr-modal-content-close-btn'>X</div>
          <div className='htr-modal-content-wrap'>
            <InnerBlocks.Content />
          </div>
        </dialog>
      )}
    </div>
  );
};

export default save;
